import React from "react";
import MaterialIcon from "../../../components/MaterialIcon";
import { Avatar } from "./CockpitPrimitives";

export default function CockpitHeader({
  strings,
  user,
  packageLabel,
  company,
  companyCount = 0,
  companyActive,
  onOpenCompanyPanel,
  onOpenProfile,
  onOpenSettings,
  onBack,
}) {
  const displayName = `${user?.firstName || ""} ${user?.lastName || ""}`.trim();
  const profileLabel = strings.cockpit_personal_settings || "Persönliche Einstellungen";
  const companyLabel = strings.cockpit_companies || "Firmen";
  const manyCompanies = companyCount > 1;
  return (
    <header className="cockpit-head">
      <div className="cockpit-head-text">
        {onBack ? (
          <>
            <div className="cockpit-eyebrow cockpit-eyebrow--accent">
              {packageLabel} · {strings.cockpit_title || "Cockpit"}
            </div>
            <button type="button" className="kj-btn kj-btn--ghost kj-btn--neutral cockpit-company-back cockpit-head-back" onClick={onBack}>
              <MaterialIcon icon="arrow_back" size={18} color="currentColor" weight={400} />
              <span>{strings.cockpit_back || "Zurück zur Übersicht"}</span>
            </button>
          </>
        ) : (
          <>
            <h1 className="cockpit-h1 cockpit-greeting">{strings.cockpit_day_overview || "Dein Tag im Überblick"}</h1>
          </>
        )}
      </div>
      <div className="cockpit-head-right">
        {company ? (
          <div className="cockpit-field cockpit-account-field">
            <div className={`cockpit-account${companyActive ? " cockpit-account--on" : ""}`}>
              <button
                type="button"
                className="cockpit-account-profile"
                onClick={onOpenCompanyPanel}
                aria-pressed={!!companyActive}
                title={manyCompanies ? companyLabel : company.name}
              >
                {manyCompanies ? (
                  <span className="cockpit-avatar cockpit-avatar--companies">
                    <MaterialIcon icon="domain" size={17} color="currentColor" weight={400} />
                  </span>
                ) : (
                  <Avatar image={company.logo} name={company.name} size={28} />
                )}
                <span className="cockpit-account-name">{manyCompanies ? companyLabel : company.name}</span>
              </button>
            </div>
          </div>
        ) : null}
        {onOpenSettings || onOpenProfile ? (
          <div className="cockpit-field cockpit-account-field">
            <div className="cockpit-account">
              <button
                type="button"
                className="cockpit-account-profile cockpit-account-profile--settings"
                onClick={onOpenSettings || onOpenProfile}
                title={profileLabel}
                aria-label={displayName ? `${displayName}, ${profileLabel}` : profileLabel}
              >
                <Avatar user={user} size={28} />
                {displayName ? <span className="cockpit-account-name">{displayName}</span> : null}
                <MaterialIcon icon="settings" size={20} color="currentColor" weight={400} />
              </button>
            </div>
          </div>
        ) : null}
      </div>
    </header>
  );
}
